<script>
import { reactive, ref, onMounted } from 'vue'

export default {
  props: [
    'text',
    'focusPosition',
    'weight',
    'stick'
  ],
  setup (props) {
    const textarea = ref(null)
    onMounted(() => {
      textarea.value.focus()
      textarea.value.selectionStart = props.focusPosition
      textarea.value.selectionEnd = props.focusPosition
    })

    const content = props.text + ''

    return reactive({
      content,
      textarea,
      stop: false
    })
  },
  computed: {
    rows () {
      const rows = this.content.split(/\n/g)
      return rows.reduce(
        (count, row) => count + Math.floor(row.length / 50), rows.length
      )
    }
  },
  methods: {
    emit () {
      if (this.stop) { // stickと重複して実行されるのを防ぐため
        this.stop = false
        return false
      }
      let values = this.content.trim().split(/\n\n/g)
      values = values.map(value => value.trim())
      values = values.filter(value => value)
      this.$emit('commit', values.map(value => {
        const p = {
          type: 'text',
          content: value
        }
        if (this.weight) {
          p.weight = this.weight
        }
        return p
      }))
    },
    keydown (e) {
      if (
        this.stick &&
        e.keyCode === 8 &&
        this.textarea.selectionStart === 0 &&
        this.textarea.selectionEnd === 0
      ) {
        e.preventDefault()
        this.stop = true
        this.$emit('stick', this.content)
      }
    }
  }
}
</script>

<template>
  <textarea
    class="ff-textarea"
    v-model="content"
    ref="textarea"
    @keydown="keydown"
    @blur="emit"
    :rows="rows"
    placeholder="テキストを入力してください"
  ></textarea>
</template>

<style lang="scss" scoped>
textarea.ff-textarea {
  padding: 0;
  border: solid 1px gray;
  margin: 0 !important;
  height: auto;
}
</style>
